// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"539":"d043bc38","740":"fbf8461d"}[chunkId] + ".chunk.js";
};